import React, { Component } from 'react';
import moment from 'moment';
import './AlertLateProject.css';

class AlertLateProject extends Component {

	render() {

		return (
			<div className="AlertLateProject">
				<div className="alertText">
					<div className="title">Your project needs action</div>
					<div className="description">
						Your project was created in {moment(this.props.data.project_created_at).format('YYYY')}. It was supposed to be sheeped in the same year. You now have two options: <br/><br/> - if you have the bill for the purchase that you did in {moment(this.props.data.project_created_at).format('YYYY')}, you can now sheep the project (only {moment(this.props.data.project_created_at).format('YYYY')} cagnottes will be impacted).<br/>OR<br/> - you can move the project to {moment().format('YYYY')}, but note that all transactions will be taken on {moment().format('YYYY')} cagnottes.
					</div>
				</div>
				<div className="actions">
					<div className="button is-close" onClick={() => this.props.achieveProject()}>
						Sheep the project
					</div>
					<div className="button is-special" onClick={() => this.props.moveProjectToCurrentYear()}>
						Move the project to {moment().format('YYYY')}
					</div>
				</div>
			</div>
		);
	}
}

export default AlertLateProject;



// WEBPACK FOOTER //
// ./src/components/Explore/AlertLateProject.js